var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyTimeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d5faf6",
    d: "m396.07,319.35s78.91,-122.94 42.54,-201.55c-36.36,-78.62 -123.15,-79.07 -153.15,-46.21 -18.34,20.08 -12.99,53.63 -56.41,66.6 -26.56,7.94 -45.89,-4.79 -85.48,-18.59 -39.59,-13.8 -85.55,16.2 -91.2,64.12 -6.34,53.78 42.61,81.89 69.48,101.25 26.87,19.36 13.26,51.47 24.4,81.53 11.14,30.07 190.82,61.99 249.81,-47.15Z",
    strokeWidth: 0,
    id: "path_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M177.67,439.72a42.91,9.28 0,1 0,85.82 0a42.91,9.28 0,1 0,-85.82 0z",
    strokeWidth: 0,
    id: "path_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M329.91,430.45a42.91,9.28 0,1 0,85.82 0a42.91,9.28 0,1 0,-85.82 0z",
    strokeWidth: 0,
    id: "path_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M193.2,421.17a111.35,9.28 0,1 0,222.7 0a111.35,9.28 0,1 0,-222.7 0z",
    strokeWidth: 0,
    id: "path_3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M58.02,414.86a111.35,9.28 0,1 0,222.7 0a111.35,9.28 0,1 0,-222.7 0z",
    strokeWidth: 0,
    id: "path_4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "M143.19,232.61m-70.72,0a70.72,70.72 0,1 1,141.45 0a70.72,70.72 0,1 1,-141.45 0",
    strokeWidth: 0,
    id: "path_5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6ffff",
    d: "M143.19,232.61m-61.26,0a61.26,61.26 0,1 1,122.52 0a61.26,61.26 0,1 1,-122.52 0",
    strokeWidth: 0,
    id: "path_6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffaff",
    fillOpacity: 0.57,
    d: "m165.1,234.99c8.54,-12.91 9.45,-36.18 5.16,-48.57 -7.83,-4.6 -16.92,-7.28 -26.65,-7.35 -29.57,-0.23 -53.73,23.55 -53.96,53.12 -0.07,8.55 1.88,16.64 5.39,23.84 0.42,0.06 0.86,0.02 1.25,0.18 19.56,8.15 52.75,3.06 68.81,-21.22Z",
    strokeOpacity: 0.57,
    strokeWidth: 0,
    id: "path_7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M141.66,189.43L141.75,177.96A1.87,1.87 45.45,0 1,143.63 176.11L143.63,176.11A1.87,1.87 45.45,0 1,145.49 177.99L145.4,189.46A1.87,1.87 45.45,0 1,143.52 191.32L143.51,191.32A1.87,1.87 45.45,0 1,141.66 189.43z",
    strokeWidth: 0,
    id: "path_8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M140.89,287.23L140.98,275.76A1.87,1.87 45.45,0 1,142.87 273.9L142.87,273.9A1.87,1.87 45.45,0 1,144.72 275.79L144.63,287.25A1.87,1.87 45.45,0 1,142.75 289.11L142.75,289.11A1.87,1.87 45.45,0 1,140.89 287.23z",
    strokeWidth: 0,
    id: "path_9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M184.48,232.93L184.48,232.93A1.87,1.87 45.45,0 1,186.37 231.07L197.83,231.16A1.87,1.87 45.45,0 1,199.69 233.05L199.69,233.05A1.87,1.87 45.45,0 1,197.81 234.91L186.34,234.82A1.87,1.87 45.45,0 1,184.48 232.93z",
    strokeWidth: 0,
    id: "path_10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M86.69,232.17L86.69,232.16A1.87,1.87 45.45,0 1,88.57 230.31L100.04,230.4A1.87,1.87 45.45,0 1,101.9 232.28L101.9,232.28A1.87,1.87 45.45,0 1,100.01 234.14L88.54,234.05A1.87,1.87 45.45,0 1,86.69 232.17z",
    strokeWidth: 0,
    id: "path_11"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M168.66,189.28m-1.87,0a1.87,1.87 0,1 1,3.74 0a1.87,1.87 0,1 1,-3.74 0",
    strokeWidth: 0,
    id: "path_12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M117.72,275.94m-1.87,0a1.87,1.87 0,1 1,3.74 0a1.87,1.87 0,1 1,-3.74 0",
    strokeWidth: 0,
    id: "path_13"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M186.91,207.82m-1.87,0a1.87,1.87 0,1 1,3.74 0a1.87,1.87 0,1 1,-3.74 0",
    strokeWidth: 0,
    id: "path_14"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M99.47,257.4m-1.87,0a1.87,1.87 0,1 1,3.74 0a1.87,1.87 0,1 1,-3.74 0",
    strokeWidth: 0,
    id: "path_15"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M186.52,258.08m-1.87,0a1.87,1.87 0,1 1,3.74 0a1.87,1.87 0,1 1,-3.74 0",
    strokeWidth: 0,
    id: "path_16"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M99.86,207.14m-1.87,0a1.87,1.87 0,1 1,3.74 0a1.87,1.87 0,1 1,-3.74 0",
    strokeWidth: 0,
    id: "path_17"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M167.98,276.33m-1.87,0a1.87,1.87 0,1 1,3.74 0a1.87,1.87 0,1 1,-3.74 0",
    strokeWidth: 0,
    id: "path_18"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M118.4,188.89m-1.87,0a1.87,1.87 0,1 1,3.74 0a1.87,1.87 0,1 1,-3.74 0",
    strokeWidth: 0,
    id: "path_19"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m162.2,218.53c5.6,-2.18 31.73,-13.43 31.73,-13.43l0.1,0.18 0.19,0.35 0.1,0.18s-23.78,15.61 -28.69,19.08c-4.91,3.47 -22.32,8.89 -22.32,8.89l-0.32,-0.59 -0.19,-0.35 -0.32,-0.59s14.12,-11.53 19.72,-13.72Z",
    strokeWidth: 0,
    id: "path_20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m125.42,236.41c-4.29,-0.66 -24.63,-2.84 -24.63,-2.84l-0,-0.2 -0.01,-0.4 -0,-0.2s20.27,-2.78 24.53,-3.58c4.26,-0.79 17.14,2.48 17.14,2.48l0.01,0.67 0.01,0.4 0.01,0.67s-12.77,3.66 -17.06,3Z",
    strokeWidth: 0,
    id: "path_21"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M143.19,232.61m-3.74,0a3.74,3.74 0,1 1,7.49 0a3.74,3.74 0,1 1,-7.49 0",
    strokeWidth: 0,
    id: "path_22"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m106.01,309.09l-16.66,99.78c-0.19,1.15 0.69,2.19 1.86,2.19h0c0.89,0 1.65,-0.62 1.84,-1.49l21.81,-100.49h-8.85Z",
    strokeWidth: 0,
    id: "path_23"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m122.12,303.1l-11.74,100.48c-0.14,1.16 0.8,2.16 1.97,2.1h0c0.89,-0.04 1.62,-0.7 1.77,-1.57l16.85,-101.44 -8.84,0.44Z",
    strokeWidth: 0,
    id: "path_24"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m190.98,309.09l16.66,99.78c0.19,1.15 -0.69,2.19 -1.86,2.19h0c-0.89,0 -1.65,-0.62 -1.84,-1.49l-21.81,-100.49h8.85Z",
    strokeWidth: 0,
    id: "path_25"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m174.88,303.1l11.74,100.48c0.14,1.16 -0.8,2.16 -1.97,2.1h0c-0.89,-0.04 -1.62,-0.7 -1.77,-1.57l-16.85,-101.44 8.84,0.44Z",
    strokeWidth: 0,
    id: "path_26"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "M93.6,302.2L205.08,302.2A4.61,4.61 0,0 1,209.69 306.8L209.69,306.8A4.61,4.61 0,0 1,205.08 311.41L93.6,311.41A4.61,4.61 0,0 1,88.99 306.8L88.99,306.8A4.61,4.61 0,0 1,93.6 302.2z",
    strokeWidth: 0,
    id: "path_27"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9bca6a",
    d: "m357.54,422.29h-121.78c-8.62,0 -22.01,-6.48 -21.01,-15.1l37.2,-258.91c1,-8.62 8.8,-15.61 17.42,-15.61l114.33,-4.46c13.9,0 22.25,11.44 21.25,20.06l-29.98,258.4c-1,8.62 -8.8,15.61 -17.42,15.61Z",
    strokeWidth: 0,
    id: "path_28"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m348.56,417.76h-121.78c-8.62,0 -14.8,-6.99 -13.8,-15.61l29.98,-258.4c1,-8.62 8.8,-15.61 17.42,-15.61h121.78c8.62,0 14.8,6.99 13.8,15.61l-29.98,258.4c-1,8.62 -8.8,15.61 -17.42,15.61Z",
    strokeWidth: 0,
    id: "path_29"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5e07b",
    d: "m348.53,412.34h-120.47c-6.56,0 -11.26,-5.32 -10.5,-11.88l29.69,-255.91c0.76,-6.56 6.7,-11.88 13.26,-11.88h120.47c6.56,0 11.26,5.32 10.5,11.88l-29.69,255.91c-0.76,6.56 -6.7,11.88 -13.26,11.88Z",
    strokeWidth: 0,
    id: "path_30"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m299.24,405.9h-25.11c-2.91,0 -5.01,-2.38 -4.67,-5.29h0c0.34,-2.91 2.99,-5.29 5.9,-5.29h25.11c2.91,0 5.01,2.38 4.67,5.29h0c-0.34,2.91 -2.99,5.29 -5.9,5.29Z",
    strokeWidth: 0,
    id: "path_31"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#9bca6a",
    d: "M260.32,145.04a3.75,4.21 46.66,1 0,6.12 -5.77a3.75,4.21 46.66,1 0,-6.12 5.77z",
    strokeWidth: 0,
    id: "path_32"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#9bca6a",
    d: "M272.17,143.9a2.26,2.53 46.66,1 0,3.69 -3.48a2.26,2.53 46.66,1 0,-3.69 3.48z",
    strokeWidth: 0,
    id: "path_33"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M356.67,389.29l-132.41,0l27.44,-236.56l132.41,0l-27.45,236.56z",
    strokeWidth: 0,
    id: "path_34"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "m365.79,189.23h-104.1c-3.2,0 -5.49,-2.59 -5.12,-5.79l2.1,-18.12c0.37,-3.2 3.26,-5.79 6.46,-5.79h104.1c3.2,0 5.49,2.59 5.12,5.79l-2.1,18.12c-0.37,3.2 -3.26,5.79 -6.46,5.79Z",
    strokeWidth: 0,
    id: "path_35"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M275.82,221.79l-23.69,0l2.75,-23.69l23.69,0l-2.75,23.69z",
    strokeWidth: 0,
    id: "path_36"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#acdaff",
    d: "M306.48,221.79l-23.7,0l2.75,-23.69l23.7,0l-2.75,23.69z",
    strokeWidth: 0,
    id: "path_37"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M337.14,221.79l-23.7,0l2.75,-23.69l23.7,0l-2.75,23.69z",
    strokeWidth: 0,
    id: "path_38"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M367.8,221.79l-23.7,0l2.75,-23.69l23.69,0l-2.75,23.69z",
    strokeWidth: 0,
    id: "path_39"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M272.3,252.09l-23.7,0l2.75,-23.69l23.7,0l-2.75,23.69z",
    strokeWidth: 0,
    id: "path_40"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M302.96,252.09l-23.69,0l2.75,-23.69l23.7,0l-2.75,23.69z",
    strokeWidth: 0,
    id: "path_41"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M333.63,252.09l-23.7,0l2.75,-23.69l23.7,0l-2.75,23.69z",
    strokeWidth: 0,
    id: "path_42"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M364.29,252.09l-23.7,0l2.75,-23.69l23.7,0l-2.75,23.69z",
    strokeWidth: 0,
    id: "path_43"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M268.79,282.39l-23.69,0l2.75,-23.7l23.69,0l-2.75,23.7z",
    strokeWidth: 0,
    id: "path_44"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M299.45,282.39l-23.69,0l2.75,-23.7l23.69,0l-2.75,23.7z",
    strokeWidth: 0,
    id: "path_45"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M330.11,282.39l-23.69,0l2.75,-23.7l23.69,0l-2.75,23.7z",
    strokeWidth: 0,
    id: "path_46"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M360.77,282.39l-23.69,0l2.75,-23.7l23.69,0l-2.75,23.7z",
    strokeWidth: 0,
    id: "path_47"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M265.27,312.69l-23.69,0l2.75,-23.7l23.69,0l-2.75,23.7z",
    strokeWidth: 0,
    id: "path_48"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M295.93,312.69l-23.69,0l2.75,-23.7l23.7,0l-2.75,23.7z",
    strokeWidth: 0,
    id: "path_49"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M326.59,312.69l-23.7,0l2.75,-23.7l23.69,0l-2.75,23.7z",
    strokeWidth: 0,
    id: "path_50"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f2ff",
    d: "M357.26,312.69l-23.7,0l2.75,-23.7l23.7,0l-2.75,23.7z",
    strokeWidth: 0,
    id: "path_51"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "m185.17,270.66s12.45,-18.12 14.42,-22.43c1.97,-4.31 2.19,-7.98 -0.9,-10.22s-8.79,-4 -13.83,3.1c-5.04,7.1 -14.35,28.91 -14.73,35.73s30.47,27.48 33.22,28.82c3.02,-0.79 4.3,-5.3 4.3,-5.3 0,0 -19.92,-25.29 -22.47,-29.7Z",
    strokeWidth: 0,
    id: "path_52"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#f79e77",
    d: "m195.38,420.57s0.63,3.58 -1.42,8.98 -2.16,7.1 0,8.3 3.69,1.53 9.72,0c6.02,-1.53 12.73,-4.89 12.73,-4.89 0,0 -6.53,-4.15 -8.13,-5.91s-4.94,-8.07 -4.89,-8.98 -8.01,2.5 -8.01,2.5Z",
    strokeWidth: 0,
    id: "path_53"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c2c51",
    d: "m211.76,429.84c-2.42,1.62 -4.74,3.38 -7.84,2.94 -2.49,-0.62 -3.43,-3.12 -4.98,-4.98 -1.07,-0.86 -2.74,-1.13 -4.18,-0.7 -0.2,0.76 -0.46,1.58 -0.79,2.45 -2.05,5.4 -2.16,7.1 0,8.3 2.16,1.19 3.69,1.53 9.72,0 6.02,-1.53 12.73,-4.89 12.73,-4.89 0,0 -2.4,-1.52 -4.64,-3.12Z",
    strokeWidth: 0,
    id: "path_54"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb797",
    d: "m268.45,234.12l7.54,3.25c2.5,-3.1 4.38,-5.44 5.61,-5.69 3.19,0.43 4.56,-0.92 5.42,-2.01 0.85,-1.09 -0.21,-1.72 -0.08,-2.13 0.88,-1.3 -0.61,-1.81 -0.37,-2.12 0.93,-1.08 0.75,-1.67 0.2,-1.96 -0.56,-0.3 -1.5,-0.57 -1.33,-1.12 0.17,-0.54 2.47,-1.99 4.46,-2.94 2,-0.94 4.19,-2.46 2.97,-3.26s-12.55,4.65 -14.67,6.97c-2.12,2.32 -1.58,4.8 -4.24,7.36 -0.96,0.93 -3.1,2.3 -5.52,3.65Z",
    strokeWidth: 0,
    id: "path_55"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffae83",
    d: "m203.26,419.47s0.53,7.35 -1.82,13.34 -1.67,8.64 2.58,9.85 6.59,-1.67 12.12,-1.51c5.53,0.15 12.88,-0.46 14.77,-5.53 1.89,-5.08 -6.95,-2.81 -12.3,-4.4s-2.97,-10.98 -2.97,-10.98l-12.38,-0.76Z",
    strokeWidth: 0,
    id: "path_56"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f3163",
    d: "m218.77,431.1c-0.48,1.61 3.88,3.31 2.6,4.17 -4.67,3.43 -10.28,-2.49 -15.57,-4.36 -1.08,-0.54 -2.37,-0.56 -3.62,-0.3 -0.2,0.74 -0.44,1.48 -0.73,2.19 -2.35,5.99 -1.67,8.64 2.58,9.85 4.24,1.21 6.59,-1.67 12.12,-1.51 5.53,0.15 15.99,-0.9 17.89,-5.97 1.88,-5.03 -9.9,-2.57 -15.26,-4.06Z",
    strokeWidth: 0,
    id: "path_57"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c2c51",
    d: "m233.38,432.74c-0.03,0.12 -0.06,0.24 -0.11,0.37 -1.89,5.08 -12.36,6.12 -17.89,5.97s-7.88,2.73 -12.12,1.51c-1.46,-0.42 -2.48,-1.01 -3.12,-1.84 0.18,2.02 1.44,3.2 3.88,3.89 4.24,1.21 6.59,-1.67 12.12,-1.51 5.53,0.15 15.99,-0.9 17.89,-5.97 0.43,-1.16 0.13,-1.92 -0.65,-2.42Z",
    strokeWidth: 0,
    id: "path_58"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#144182",
    d: "m212.21,325.22c-2.9,-1.37 -4.84,-3.41 -6.11,-5.66 -2.5,-4.47 -2.3,-9.8 -1.39,-12.52 1.36,-4.09 6.82,-14.4 6.82,-14.4l-13.41,-2.48s-6.02,10.4 -9.09,18.58c-3.07,8.18 -0.57,16.82 0.91,23.3 1.48,6.48 5.23,25 3.64,31.93 -1.59,6.93 -4.55,17.5 -3.75,25.57 0.8,8.07 4.77,27.28 4.66,31.59 1.34,0.6 2.66,0.8 3.87,0.77 3.62,-0.09 6.36,-2.25 6.36,-2.25 0,0 0.91,-33.07 4.32,-47.62 3.41,-14.55 6.82,-41.6 3.18,-46.82Z",
    strokeWidth: 0,
    id: "path_59"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f3163",
    d: "m212.21,325.22c-2.9,-1.37 -4.84,-3.41 -6.11,-5.66 -5.68,-2.68 -1.72,-13.1 -2.18,-19.53 -2.25,6.2 -10.84,17.39 0.9,31.33 4.18,3.88 0.1,34.35 -3.48,48.09 -3.21,11.65 -1.81,30.36 -1.24,42.26 2.71,-0.56 4.6,-2.05 4.6,-2.05 0,0 0.91,-33.07 4.32,-47.62 3.41,-14.55 6.82,-41.6 3.18,-46.82Z",
    strokeWidth: 0,
    id: "path_60"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#144182",
    d: "m233.65,292.49s3.94,15 2.73,31.06 -11.97,43.03 -13.18,48.94 -2.88,22.9 -4.39,30.55 -2.27,14.76 -1.44,16.73c-3.56,3.79 -13.03,3.33 -15.15,0 0.76,-15.61 0.38,-29.02 3.33,-39.55s1.14,-13.26 2.35,-19.85 2.42,-26.97 3.03,-29.4 -5.45,-3.64 -7.65,-7.58c-2.2,-3.94 -6.74,-13.41 5.83,-32.73 13.41,-0.46 24.55,1.82 24.55,1.82Z",
    strokeWidth: 0,
    id: "path_61"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#164e91",
    d: "m233.65,292.49s-11.14,-2.27 -24.55,-1.82c-0.25,0.39 -0.49,0.76 -0.72,1.14 11.06,0.14 19.53,1.87 19.53,1.87 0,0 3.94,15 2.73,31.06 -1.21,16.06 -9.8,42.59 -11.02,48.5 -1.21,5.91 -1.69,22.13 -3.21,29.77 -1.31,6.59 -1.55,14.79 -1.05,18.19 0.77,-0.38 1.46,-0.85 2,-1.43 -0.83,-1.97 -0.08,-9.09 1.44,-16.73 1.51,-7.64 3.18,-24.64 4.39,-30.55 1.21,-5.91 11.97,-32.88 13.18,-48.94 1.21,-16.06 -2.73,-31.06 -2.73,-31.06Z",
    strokeWidth: 0,
    id: "path_62"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffae83",
    d: "m226.75,201.87s1.14,13.49 -0.38,17.65 -3.03,7.2 -3.86,8.03 -4.84,-0.68 -5.64,0 -0.72,8.49 -0.72,8.49l-11.14,-0.46s1.29,-14.09 2.27,-17.96 18.33,-16.06 19.47,-15.76Z",
    strokeWidth: 0,
    id: "path_63"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fa0",
    d: "m200.39,235.32s8.64,-4.32 15.68,-0.91 18.07,17.73 19.77,20.46 2.84,8.86 0,14.43 -1.82,21.93 -0.34,24.77c-11.93,3.52 -30.46,1.25 -38.98,-2.5 4.77,-6.93 7.27,-9.55 3.86,-17.16s-7.5,-29.21 0,-39.1Z",
    strokeWidth: 0,
    id: "path_64"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "m230.48,270.35c2.84,-5.57 1.71,-11.71 0,-14.43 -1.71,-2.73 -12.73,-17.05 -19.77,-20.46 -2.43,-1.18 -5.05,-1.42 -7.44,-1.25 -1.75,0.56 -2.88,1.11 -2.88,1.11 -7.5,9.89 -3.41,31.48 0,39.1 3.41,7.61 0.91,10.23 -3.86,17.16 7.17,3.16 21.43,5.26 32.88,3.76 0.25,-0.07 0.5,-0.13 0.74,-0.2 -1.48,-2.84 -2.5,-19.21 0.34,-24.77Z",
    strokeWidth: 0,
    id: "path_65"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbc00",
    d: "m243.91,251.8s-17.98,-12.64 -22.27,-14.66 -7.95,-2.27 -10.23,0.8 -4.09,8.75 2.95,13.86c7.05,5.11 28.75,14.66 35.57,15.11 6.82,0.46 27.81,-30.18 29.17,-32.9 -0.76,-3.03 -5.26,-4.36 -5.26,-4.36 0,0 -25.5,19.65 -29.94,22.15Z",
    strokeWidth: 0,
    id: "path_66"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff69a6",
    d: "m214.37,251.8c-0.24,-0.17 -0.44,-0.34 -0.67,-0.51 0.21,0.17 0.43,0.34 0.67,0.51Z",
    strokeWidth: 0,
    id: "path_67"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd815",
    d: "m210.97,240.9c2.27,-3.07 5.94,-2.81 10.23,-0.8s21.59,13.32 21.59,13.32c4.43,-2.5 31.06,-23.78 31.06,-23.78 0,0 -25.5,19.65 -29.94,22.15 0,0 -17.98,-12.64 -22.27,-14.66s-7.95,-2.27 -10.23,0.8c-1.06,1.44 -2.03,3.44 -2.03,5.7 0.32,-0.93 0.91,-1.81 1.59,-2.73Z",
    strokeWidth: 0,
    id: "path_68"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#144182",
    d: "m225.92,195.51c-5.15,-5.15 -14.7,-7.12 -14.7,-7.12 -8.1,-2.75 -14.4,4.85 -16.21,11.67 -1.82,6.82 -0.92,14.75 -3.71,23.71 -1.41,4.37 -21.59,35.62 4.86,58.25 6.72,3.32 11.87,4.78 19.14,-0.82 -7.66,-18.21 -5.24,-35.68 -3.69,-40.92 1.49,-5.07 4.56,-5.25 7.38,-4.21 0.13,0.05 0.25,0.1 0.39,0.15 -0.26,-0.51 -0.6,-1.1 -1,-1.75 -1.42,-4.23 -0.08,-12.99 2.82,-16.09 3.41,-3.64 5,-9.55 5.57,-13.86 0.8,5.11 -1.02,8.3 -2.27,10.11 4.89,-3.75 6.59,-13.98 1.44,-19.13Z",
    strokeWidth: 0,
    id: "path_69"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f3163",
    d: "m193.48,263.26c-2.99,-20.91 5.38,-42.41 13.14,-62.12 2.32,-6.04 8.99,-8.83 15.77,-8.36 -5.08,-3.13 -11.17,-4.39 -11.17,-4.39 -8.1,-2.75 -14.4,4.85 -16.21,11.67 -1.82,6.82 -0.92,14.75 -3.71,23.71 -1.41,4.37 -21.59,35.62 4.86,58.25 5.44,2.69 9.84,4.15 15.17,1.66 -2.27,-0.41 -4.93,-1.89 -5.5,-2.35 -5.97,-4.18 -11.16,-10.9 -12.35,-18.07Z",
    strokeWidth: 0,
    id: "path_70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTimeGreen);
export default __webpack_public_path__ + "static/media/my_time_green.92c7e85baa35d6dd0235bf5338bc10e6.svg";
export { ForwardRef as ReactComponent };